import Image from "next/image";
import { cn } from "../../utils/cn";

interface CourseCardProps {
	title: string;
	imageSrc: string;
	imageAlt: string;
	onClick?: () => void;
}

const CourseCard: React.FC<CourseCardProps> = ({
	title,
	imageSrc,
	imageAlt,
	onClick,
}) => {
	return (
		<div
			className={cn(
				"flex justify-between items-center rounded-2xl border border-gray-200/20 bg-white cursor-pointer",
				"shadow-[0_0_2px_0_rgba(145,158,171,0.20),_0_12px_24px_-4px_rgba(145,158,171,0.12)]",
				"hover:shadow-lg transition-shadow",
				"min-h-[110px] p-6 gap-2",
			)}
			onClick={onClick}
		>
			<div className="flex-1">
				<span className="font-semibold text-gray-700">{title}</span>
			</div>
			<Image
				src={imageSrc}
				alt={imageAlt}
				width={40}
				height={40}
				className="w-10 h-10"
			/>
		</div>
	);
};

export default CourseCard;
